// Multi-site selection caps (QS-9518), shared by SiteSelect and the `site` filter.

import { AnyAri } from '@atlassian/ari/any-ari';

/** Max sites selectable at once, including the current/primary site. */
export const MAX_SELECTED_SITES = 5;

/**
 * `unitMetadata` site ids are ARIs (e.g. `ari:cloud:platform::site/<cloudId>`), whereas the store and
 * `useCloudId()` return bare cloudIds. Extract the cloudId (the ARI resourceId) so sites can be
 * matched against the current cloudId and keyed consistently.
 * */
export const getSiteCloudId = (siteId: string): string => {
	if (!siteId.startsWith('ari:')) {
		return siteId;
	}
	try {
		return AnyAri.parse(siteId).resourceId || siteId;
	} catch {
		return siteId;
	}
};
